import { useCallback } from "react";

import { generatePath, useHistory, useLocation, useParams } from "react-router";

import { ROUTES_COMPOSE } from "../Routes.constants";
import { useOnWindowReset } from "../compose/hooks/useOnWindowReset";
import { useWindowOpenCloseEvents } from "../compose/hooks/useWindowOpenCloseEvents";
import { InboxConversationView } from "./components/InboxConversationView";

export const ConversationPage = () => {
    const { conversationId, workspaceId } = useParams<{
        conversationId: string;
        workspaceId: string;
    }>();

    const history = useHistory();
    const { state } = useLocation();

    const resetCompose = useCallback(() => {
        history.replace({
            pathname: generatePath(ROUTES_COMPOSE.compose, {
                workspaceId,
            }),
            state,
        });
    }, [history, state, workspaceId]);

    // When window is open and user clicks on compose option
    // reset compose
    useOnWindowReset({ onReset: resetCompose });

    // When user closes the window from this page, just reset compose
    useWindowOpenCloseEvents({
        onOpen: () => {
            /*Do nothing*/
        },
        onClose: resetCompose,
    });

    return <InboxConversationView conversationId={conversationId} />;
};
